import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDevpostComponent } from './simple-icons-devpost.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDevpostComponent ],
    exports:      [ SimpleIconsDevpostComponent ],
    bootstrap:    []
})
export class SimpleIconsDevpostModule {}
